// extracted by mini-css-extract-plugin
module.exports = {"colorSwatch":"ColorSwatch_colorSwatch__2SMtg","box":"ColorSwatch_box__3M3a9","title":"ColorSwatch_title__akusy","color":"ColorSwatch_color__31sSh"};